import React from "react";

export const Sessions: React.FC = () => {
  return <div>Sessions</div>;
};
